import React from 'react';
import Select, {selectType} from 'Components/Select';
import { Input, MultiInput } from 'Components/Input';

export default class AdditionalSection extends React.Component {
  getInputValue = id => {
    const {boatSystems, currentSystem} = this.props;
    const activeSystem = boatSystems[currentSystem.index];

    if (!activeSystem) return '';
    const element = activeSystem.optionValueRequests.find(option => option.optionId === id);

    if (element) return element.value;
    return '';
  };

  render() {
    const {currentSystem, handleAdditionalInput, additionalSectionName} = this.props;

    if (!currentSystem.options || !currentSystem.options.length) return null;

    return (
      <section className='scene_section _block'>
        <header>
          {additionalSectionName}
        </header>
        {currentSystem.options.sort((a, b) => a.id - b.id).map(input => {
          let units = '';
          switch (input.optionType) {
            case 'INCHES':
              units = 'In.';
              break;
            case 'SQUARE_INCHES':
              units = 'Sq. In.';
              break;
            case 'CUBUC_FOOT':
              units = 'Cu. Ft.';
              break;
            default:
              break;
          }

          switch (input.optionType) {
            case 'VARIANTS':
              return (
                <div
                  key={input.id}
                  className={`boat-systems-scene__additional-info-single-input-wrapper ${
                    currentSystem.id === 1 ? 'blow' : ''
                  }`}
                >
                  <Select
                    defaultItem={this.getInputValue(input.id)}
                    type={selectType.primary}
                    mainWrapperClassName='_width_210 _margin_top_0'
                    inputClassName='_border_radius_10 _height_40  _margin_top_12'
                    dropDownClassName='_border_radius_bottom_left_10 _border_radius_bottom_right_10'
                    selectionList={input.optionVariants.split(', ')}
                    label={input.name}
                    handleSelect={handleAdditionalInput(input.id)}
                  />
                </div>
              );
            case 'INTEGER':
            case 'INCHES':
            case 'STRING':
            case 'SQUARE_INCHES':
            case 'CUBUC_FOOT':
              return (
                <div
                  key={input.id}
                  className={`boat-systems-scene__additional-info-single-input-wrapper ${
                    currentSystem.id === 1 ? 'blow' : ''
                  }`}
                >
                  <Input
                    isNumeric
                    inputClassName='_border_radius_10 _margin_top_12 _height_40 _width_210'
                    label={input.name}
                    value={this.getInputValue(input.id)}
                    onChange={handleAdditionalInput(input.id)}
                    units={units}
                  />
                </div>
              );
            default:
              return (
                input.options.map(input => {
                  if (input.optionType === null) {
                    return (
                      <div key={input.id} className='boat-systems-scene__additional-info-multi-input-wrapper'>
                        <div className='boat-systems-scene__additional-info-multi-input-label'>{input.name}</div>
                        <div className='boat-systems-scene__additional-info-multi-input-fields-wrapper'>
                          {input.options.map(input => (
                            <MultiInput
                              key={input.id}
                              label={input.name}
                              value={this.getInputValue(input.id)}
                              onChange={handleAdditionalInput(input.id)}
                              units={input.optionType === 'SQUARE_INCHES' ? 'Sq. In.' : ''}
                              numbersOnly
                              styles={{ width: 110, height: 40 }}
                            />
                          ))}
                        </div>
                      </div>
                    );
                  }
                  return null;
                }));
          }
        })}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/AddComponents/AdditionalSection.jsx